import React from 'react';

const CovidInfoContainer = () => {
    return (
        <div className="container">
            <div className="covid-container">
                <h1>Microsoft’s response to COVID-19</h1>
                <p>Read how we’re responding to the COVID-19 outbreak, and get resources to help.</p>
                <a href="https://news.microsoft.com/covid-19-response/?icid=mscom_marcom_BM1a_covid19response" class="active-link"><span>Learn more </span> <i class="fa fa-angle-right"></i></a>
            </div>
        </div>
    )
}

export default CovidInfoContainer;